import { render, staticRenderFns } from "./CreateEditPermissions.vue?vue&type=template&id=5fb52a96&scoped=true"
import script from "./CreateEditPermissions.vue?vue&type=script&lang=js"
export * from "./CreateEditPermissions.vue?vue&type=script&lang=js"
import style0 from "./CreateEditPermissions.vue?vue&type=style&index=0&id=5fb52a96&prod&lang=scss&scoped=true"
import style1 from "./CreateEditPermissions.vue?vue&type=style&index=1&id=5fb52a96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb52a96",
  null
  
)

export default component.exports